import { useEffect, useRef, useState } from 'react';
import useDocumentTitle from '../../../../hooks/useDocumentTitle';
import { ProductsService } from '../../../../services/ProductsService';
import { useLoader } from '../../../../context/LoaderContext';
import { ToasterService } from '../../../../services/ToasterService';
import { useNavigate } from 'react-router-dom';

export default function UseOurProductsPage() {
  const navigate = useNavigate();
  // useDocumentTitle('Namasteji Manikchand - Our Products');
  const [selectedFilter, setSelectedFilter] = useState<any>('All');
  const [productsList, setProductsList] = useState<any[]>([]);
  const [itemGroups, setItemGroups] = useState<string[]>([]);
  const { setLoading } = useLoader();
  const getUserLoginData = localStorage.getItem('userLoginData');
  let parsedUserData: any = {};
  const customerId = useRef('');

  useEffect(() => {
    if (getUserLoginData) {
      parsedUserData = JSON.parse(getUserLoginData);
      if (parsedUserData && parsedUserData.customer_id && parsedUserData.customer_id !== '') {
        customerId.current = parsedUserData.customer_id;
      }
    }
    getProductsList();
  }, []);

  async function getProductsList() {
    setLoading(true);
    try {
      const resp = await ProductsService.List();
      if (resp && resp.message && resp.message.success == 200) {
        const apiResp = resp.message;
        const apiData = apiResp.data;
        const products = apiData ? apiData.product_list : [];
        setLoading(false);
        if (products && products.length > 0) {
          setProductsList(products);
          const uniqueGroups: any = Array.from(new Set(products.map((item: any) => item.item_group).filter(Boolean)));
          const finalGroups = ['All', ...uniqueGroups];
          // console.log("Final Item Groups:", products);
          setItemGroups(finalGroups);
        } else {
          ToasterService.Error('Currently Products not available.');
        }
      }
    } catch (error) {
      setLoading(false);
      ToasterService.Error('Server Error! Please wait....');
    }
  }

  const filteredProducts =
    selectedFilter === 'All' ? productsList : productsList.filter(product => product.item_group === selectedFilter);

  function goToProductDetailsPage(itemCode: string) {
    if (itemCode && itemCode != '') {
      // navigate('/product/details', {
      //     state: { itemCode },
      // });
      navigate(`/product/details/${itemCode}`);
    } else {
      ToasterService.Error('Something went wrong. Please try again later.');
    }
  }

  const states = {
    productsList,
    selectedFilter,
    filteredProducts,
    setSelectedFilter,
    itemGroups,
  };

  return {
    states,
    goToProductDetailsPage,
    navigate,
    customerId,
  };
}
